import { MagentoGraphQLRequestClientError } from "@jti/magento-api-v2";

import { ADDRESS_VALIDATION_CATEGORY, ADDRESS_VALIDATION_CODE, SHORT_ADDRESS_VALIDATION_CODE } from "../../constants";

const customShippingAddressErrorCodes: unknown[] = [SHORT_ADDRESS_VALIDATION_CODE];

/**
 * Determine whether the provided error
 * represents an address validation GraphQL error.
 */
export const isExternalAddressValidationGraphqlError = (error: unknown): boolean => {
  if (!error || !MagentoGraphQLRequestClientError.isMagentoGraphQLRequestClientError(error)) {
    return false;
  }

  return (
    error.response?.errors?.some(
      ({ extensions }) =>
        !customShippingAddressErrorCodes.includes(extensions.code) &&
        (extensions.category === ADDRESS_VALIDATION_CATEGORY || extensions.code === ADDRESS_VALIDATION_CODE)
    ) ?? false
  );
};
